var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.47 8.53c-.922-.921-2.045-1.58-3.117-1.795a.75.75 0 01.294-1.47c1.428.285 2.805 1.126 3.883 2.205 1.079 1.078 1.92 2.455 2.205 3.883a.75.75 0 01-1.47.294c-.215-1.072-.874-2.195-1.795-3.117z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.665 2.042a.75.75 0 01.707-.79c.327-.014 3.88-.071 7.16 3.219 2.537 2.545 3.084 5.241 3.194 6.468.02.227.034.458.023.687a.75.75 0 01-.789.709c-.427-.023-.72-.39-.709-.804.006-.261.009-3.202-2.782-6.001-1.725-1.73-3.504-2.385-4.677-2.633-.436-.092-.89-.16-1.336-.148a.75.75 0 01-.79-.707z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.646 3.614a.75.75 0 00-1.06-.238l-2.999 2c-.848.565-1.394 1.657-1.332 2.669.456 7.482 7.223 14.24 14.7 14.7 1.013.062 2.104-.484 2.67-1.332l2-3a.75.75 0 00-.24-1.059l-4.998-3a.75.75 0 00-.917.113l-1.675 1.676c-.432-.199-1.338-.746-2.762-2.175-1.421-1.427-1.971-2.332-2.174-2.765l1.673-1.674a.75.75 0 00.113-.916l-3-4.999zm-.174 6.854l1.586-1.585L5.764 5.06l-2.32 1.547c-.468.372-.72.874-.692 1.347.41 6.724 6.574 12.881 13.295 13.294.472.029.976-.225 1.345-.691l1.548-2.321-3.823-2.294-1.585 1.586c-.201.2-.456.234-.723.198-.451-.086-1.652-.505-3.838-2.699-1.872-1.878-2.446-3.02-2.632-3.592-.109-.334-.137-.696.133-.967z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.171093858c77d8398bcdc5670f2a905d.svg";
export { ForwardRef as ReactComponent };